import { render, staticRenderFns } from "./AnnualReturnsEscalations.vue?vue&type=template&id=3143e4fc&scoped=true&"
import script from "./AnnualReturnsEscalations.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsEscalations.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsEscalations.vue?vue&type=style&index=0&id=3143e4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143e4fc",
  null
  
)

export default component.exports